import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faTimes, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { useEscapeKey } from "./hooks/useEscapeKey";

const SurveyWarningsModal = ({ isOpen, onClose, warnings = [], onRefresh, onNavigate }) => {
  useEscapeKey(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
        background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center",
        alignItems: "center", zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "var(--color-bg-white)",
          padding: "20px",
          borderRadius: "12px",
          width: "80%",
          maxWidth: "900px",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          border: "1px solid var(--color-blue-200)",
          boxShadow: "var(--shadow-xs, 0 10px 40px rgba(0,0,0,0.3))",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          marginBottom: "15px", borderBottom: "2px solid var(--color-blue-200)", paddingBottom: "10px",
        }}>
          <h3 style={{ margin: 0, display: "flex", alignItems: "center", gap: "8px", color: "var(--color-blue-800)" }}>
            <FontAwesomeIcon icon={faTriangleExclamation} color="var(--color-brand)" />
            Survey warnings and errors
          </h3>
          <button
            onClick={onClose}
            title="Close"
            style={{
              background: "var(--color-red-50, #fef2f2)",
              color: "var(--color-red-700, #b91c1c)",
              border: "1px solid var(--color-red-700, #b91c1c)",
              width: "30px",
              height: "30px",
              borderRadius: "var(--radius-md, 6px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: "14px",
              transition: "all var(--transition-base)",
              flexShrink: 0,
              padding: 0,
              lineHeight: 1,
            }}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <button
          onClick={onRefresh}
          style={{
            alignSelf: "flex-start", background: "none", border: "none",
            color: "var(--color-brand)", fontWeight: 600, fontSize: "13px",
            cursor: "pointer", marginBottom: "10px",
            display: "flex", alignItems: "center", gap: "6px",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "var(--color-brand-dark)")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--color-brand)")}
        >
          <FontAwesomeIcon icon={faRotateRight} /> REFRESH LIST
        </button>

        <div style={{ flex: 1, overflow: "auto" }}>
          {warnings.length === 0 ? (
            <div style={{ padding: "20px", color: "var(--color-blue-700)", fontSize: "14px" }}>
              No warnings or errors found.
            </div>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
              <thead>
                <tr style={{ textAlign: "left", color: "var(--color-blue-700)", borderBottom: "1px solid var(--color-blue-200)" }}>
                  <th style={{ padding: "8px" }}>Item ID</th>
                  <th style={{ padding: "8px" }}>Type</th>
                  <th style={{ padding: "8px" }}>Error</th>
                </tr>
              </thead>
              <tbody>
                {warnings.map((w, idx) => (
                  <tr key={idx} style={{ borderBottom: "1px solid var(--color-blue-100)" }}>
                    <td style={{ padding: "8px", color: "var(--color-blue-900)" }}>{w.itemId}</td>
                    <td style={{ padding: "8px" }}>
                      <span
                        style={{
                          background: "var(--color-action-bg)",
                          color: "var(--color-action-text)",
                          border: "1px solid var(--color-action-border)",
                          borderRadius: "999px",
                          padding: "2px 10px",
                          fontSize: "11px",
                          fontWeight: 600,
                        }}
                      >
                        {w.type}
                      </span>
                    </td>
                    <td style={{ padding: "8px" }}>
                      <button
                        onClick={() => onNavigate?.(w.key)}
                        style={{
                          background: "none", border: "none", color: "var(--color-brand)",
                          cursor: "pointer", textAlign: "left", padding: 0, fontSize: "13px",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--color-brand-dark)")}
                        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--color-brand)")}
                      >
                        {w.message}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default SurveyWarningsModal;